package org.ksdfv.thelema.data

import kotlin.native.concurrent.ThreadLocal

@ThreadLocal
object DATA: IData {
    lateinit var proxy: IData

    override val nullBuffer: IByteData
        get() = proxy.nullBuffer

    override fun decodeURI(uri: String): String = proxy.decodeURI(uri)
    override fun encodeURI(uri: String): String = proxy.encodeURI(uri)
    override fun decodeBase64(text: String): ByteArray = proxy.decodeBase64(text)
    override fun decodeBase64(text: String, out: IByteData): IByteData = proxy.decodeBase64(text, out)
    override fun encodeBase64(bytes: ByteArray): String = proxy.encodeBase64(bytes)
    override fun encodeBase64(data: IByteData): String = proxy.encodeBase64(data)
    override fun bytes(capacity: Int): IByteData = proxy.bytes(capacity)
    override fun destroyBytes(data: IByteData) = proxy.destroyBytes(data)
}
